export const convertFromGrams = (valueInGrams, unitMeasurement) => {
	const value = parseFloat(valueInGrams);

	if (isNaN(value)) {
		return 0;
	}

	switch (unitMeasurement) {
		case "kg_l":
			return value / 1000;
		case "ton_kl":
			return value / 1000000;
		case "gr_cc":
		default:
			return value;
	}
};

export const convertFromCC = (valueInCC, unitMeasurement) => {
	const value = parseFloat(valueInCC);

	if (isNaN(value)) {
		return 0;
	}

	switch (unitMeasurement) {
		case "kg_l":
			return value / 1000;
		case "ton_kl":
			return value / 1000000;
		case "gr_cc":
		default:
			return value;
	}
};

export const convertValue = (value, backendUnit, targetUnitMeasurement) => {
	if (backendUnit === "") {
		backendUnit = "g";
	}

	if (backendUnit === "u") {
		return parseFloat(value) || 0;
	}

	if (backendUnit === "g") {
		return convertFromGrams(value, targetUnitMeasurement);
	}

	if (backendUnit === "cc") {
		return convertFromCC(value, targetUnitMeasurement);
	}

	return parseFloat(value) || 0;
};
